export default "__VITE_ASSET__W_KhMLTE__"